export const Routes = {
    SEND_LOGIN_OTP: "/user/login/otp/send",
    SEND_SIGNUP_OTP: "/user/signup",
    DECODE: "/app/webRedirection/Decrypt",
    VERIFY_OTP: "/user/login/otp/verify",
    SIGNUP_VERIFY_OTP: "/user/otp",
    LINKED_ACCOUNTS: "/app/dashboard/bankaccounts",
    DISCOVER_ACCOUNTS: "/app/accounts/discover",
    LINK_ACCOUNTS: "/app/accounts/link",
    CONFIRM_LINKING: "/app/accounts/otp",
    CONSENT_REQUEST_DETAILS: "/app/consent",
    CONSENT_APPROVAL: "/app/consent/confirm",
    SIGN_OUT: "/User/sign-out",
    USER_INFO: "/user/user-profile",
    IDENTIFIERS: "/User/Identifiers",
    IDENTIFIERS_VERIFY: "/app/otp/validate",
    FIP_LIST: "/app/fip"
};
//# sourceMappingURL=RouteConstants.js.map